module.exports = __webpack_public_path__ + "static/media/logo_fruehe_hilfen_footer.c693ed26.svg";